import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const sektorIcons = {
  Pendidikan: "school",
  "Pendidikan/Penelitian": "science",
  Pertanahan: "landscape",
  "Tata Ruang": "map",
  Perdagangan: "storefront",
  Kesehatan: "local_hospital",
  Umum: "campaign",
};

function getSektorIcon(sektor) {
  return sektorIcons[sektor] || "description";
}

function ServicesSection({ layanan, loading, sektorFilter, onSektorChange, onViewDetail }) {
  const sektors = ["Semua", ...new Set(layanan.map((l) => l.sektor))];
  const filtered =
    sektorFilter === "Semua" ? layanan : layanan.filter((l) => l.sektor === sektorFilter);

  return (
    <MDBox id="layanan" component="section" py={8}>
      <Container>
        <MDBox textAlign="center" mb={4}>
          <MDTypography variant="h3" fontWeight="bold" mb={1}>
            Layanan Perizinan & Nonperizinan
          </MDTypography>
          <MDTypography variant="body2" color="text" maxWidth="40rem" mx="auto">
            15 jenis layanan DPMPTSP Kabupaten Rote Ndao. Klik &quot;Lihat Persyaratan&quot; untuk
            melihat detail berkas yang diperlukan sebelum mengajukan permohonan.
          </MDTypography>
        </MDBox>

        {!loading && sektors.length > 1 && (
          <MDBox mb={3} display="flex" justifyContent="center">
            <Tabs
              value={sektorFilter}
              onChange={(_e, val) => onSektorChange(val)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{ maxWidth: "100%" }}
            >
              {sektors.map((s) => (
                <Tab key={s} label={s} value={s} />
              ))}
            </Tabs>
          </MDBox>
        )}

        <Grid container spacing={3}>
          {loading && (
            <Grid item xs={12}>
              <MDTypography textAlign="center">Memuat layanan...</MDTypography>
            </Grid>
          )}
          {!loading &&
            filtered.map((item) => (
              <Grid item xs={12} sm={6} lg={4} key={item.id}>
                <Card sx={{ height: "100%", transition: "transform 0.2s, box-shadow 0.2s", "&:hover": { transform: "translateY(-4px)", boxShadow: 6 } }}>
                  <MDBox p={3} display="flex" flexDirection="column" height="100%">
                    <MDBox display="flex" alignItems="center" gap={1} mb={2}>
                      <MDBox
                        variant="gradient"
                        bgColor="info"
                        color="white"
                        width="2.5rem"
                        height="2.5rem"
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Icon fontSize="small">{getSektorIcon(item.sektor)}</Icon>
                      </MDBox>
                      <Chip label={item.sektor} size="small" color="info" variant="outlined" />
                    </MDBox>

                    <MDTypography variant="h6" fontWeight="medium" mb={1}>
                      {item.nama}
                    </MDTypography>
                    <MDTypography variant="caption" color="text" mb={1}>
                      {item.kode} • {item.kategori}
                    </MDTypography>
                    <MDTypography variant="button" color="text" mb={2}>
                      Waktu: {item.waktu_layanan || "1 Jam"}
                    </MDTypography>

                    <MDBox mt="auto">
                      <MDButton variant="gradient" color="info" fullWidth onClick={() => onViewDetail(item)}>
                        Lihat Persyaratan
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Container>
    </MDBox>
  );
}

ServicesSection.propTypes = {
  layanan: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  sektorFilter: PropTypes.string.isRequired,
  onSektorChange: PropTypes.func.isRequired,
  onViewDetail: PropTypes.func.isRequired,
};

export default ServicesSection;
